<template>
<div>
    <Breadcrumbs main="My Updates" submain="Requsition" title="Requisition View" />

    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div style="display: flex; justify-content: space-between; padding: 0px 12px; margin-bottom: 16px;">
            <div>
                <b-button variant="primary" @click="goBack">
                    <div style="display: flex; align-items: center; gap: 8px;">
                        <feather type="arrow-left" size="18px"></feather>
                        <h7>Back</h7>
                    </div>
                </b-button>
            </div>
            <div class="d-flex" style="gap: 16px;">
                <!--  -->
                <div  v-b-modal.modal-requisition-settlement @click="settleRequisition">
                    <b-button variant="info">
                        <div style="display: flex; align-items: center; gap: 8px;">
                            <!-- <feather type="printer" size="18px"></feather> -->
                            <h7>Settlement</h7>
                        </div>
                    </b-button>
                </div>
                <div @click="printPdf('requisition')">
                    <b-button variant="success">
                        <div style="display: flex; align-items: center; gap: 8px;">
                            <feather type="printer" size="18px"></feather>
                            <h7>Print</h7>
                        </div>
                    </b-button>
                </div>
            </div>
        </div>
        <div class="row" id="requisition">
            <div class="col-xl-8">
                
                <px-card>
                    <div slot="with-padding">
                        <div class="form theme-form">
                            <div style="display: flex; justify-content: end;">
                                <feather type="message-circle" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-scrollable @click="Reply(detail)" title="Reply"></feather>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Requisition ID</label>
                                        <p class="form-control d-flex align-items-center" style="height: 44px; font-size: 14px;">{{ requisition.requisition_id }}</p>
                                    </div>
                                </div>
                                <!-- <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Requisition ID</label>
                                        <input disabled class="form-control" type="text" placeholder="Requisition ID" v-model="requisition.requisition_id" style="height: 44px;">
                                    </div>
                                </div> -->
                                <!-- <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Raised by</label>
                                        <input disabled class="form-control" type="text" placeholder="Raised By" v-model="requisition.raised_by" style="height: 44px;">
                                    </div>
                                </div> -->
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Raised by</label>
                                        <p class="form-control d-flex align-items-center" style="height: 44px; font-size: 14px;">{{ requisition.raised_by }}</p>
                                    </div>
                                </div>
                                <!-- <div class="col-md-4">
                                    <div class="form-group">
                                        <label>Date</label>
                                        <datepicker placeholder="Select a date" input-class="datepicker-here form-control digits" v-model="requisition.date" disabled=""></datepicker>
                                    </div>
                                </div> -->
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>Date</label>
                                        <p class="form-control d-flex align-items-center" style="height: 44px; font-size: 14px;">{{ formatDate(requisition.date) }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <!-- <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Title</label>
                                        <input disabled class="form-control" type="text" placeholder="Enter requisition title" v-model="requisition.title" style="height: 44px;">
                                    </div>
                                </div> -->
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Title</label>
                                        <p class="form-control d-flex align-items-center" style="height: 44px; font-size: 14px;">{{ requisition.title }}</p>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Refer To</label>
                                        <multiselect disabled v-model="assignedMembers" tag-placeholder="Add member" placeholder="Search or add a member" label="first_name" :max="user_list.length" track-by="id" :options="user_list" :multiple="true" :taggable="true"></multiselect>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Requisition Type</label>
                                        <p class="form-control d-flex align-items-center" style="height: 44px; font-size: 14px;">{{ requisition.type?.name }}</p>
                                        <!-- <select style="height: 44px;" class="form-control digits" v-model="requisition.type" disabled>
                                            <option v-for="(type, index) in requ_types" :key="index" :value="type.id">{{ type.name }}</option>
                                        </select> -->
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Project</label>
                                        <p class="form-control d-flex align-items-center" style="height: 44px; font-size: 14px;">{{ requisition.project?.title }}</p>
                                        <!-- <select style="height: 44px;" class="form-control digits" v-model="requisition.project" disabled>
                                            <option v-for="(project, index) in projects" :key="index" :value="project.id">{{ project.title }}</option>
                                        </select> -->
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Items</label>
                                      
                                        <ItemTable v-if="requisition.details" style="margin-bottom: 10px;" id="item-table" :tableData="requisition.details"  />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4"></div>
                                <!-- <div class="col-sm-8">
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">Grand Total</label>
                                        <input style="height: 44px;" class="form-control" type="number" placeholder="Enter grand total" disabled v-model="requisition.grand_total" />
                                    </div>
                                </div> -->
                                <div class="col-sm-8">
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">Grand Total</label>
                                        <p class="form-control d-flex align-items-center" style="height: 44px; font-size: 14px;">{{ requisition.grand_total }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4"></div>
                                <!-- <div class="col-sm-8">
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">Due</label>
                                        <input style="height: 44px;" class="form-control" type="number" placeholder="" disabled v-model="requisition.due_amount" />
                                    </div>
                                </div> -->
                                <div class="col-sm-8">
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">Due</label>
                                        <p class="form-control d-flex align-items-center" style="height: 44px; font-size: 14px;">{{ requisition.due_amount }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Note</label>
                                        <div class="form-control" id="exampleFormControlTextarea4" style="height: 100px;" v-html="requisition.note"></div>
                                        <!-- <textarea disabled class="form-control" id="exampleFormControlTextarea4" placeholder="Enter note..." rows="8" v-model="requisition.note"></textarea> -->
                                    </div>
                                </div>
                            </div>
                                <div style="display: flex; flex-direction: row; gap: 10px;" class="my-3">
                                <h7>Requisition Status:</h7>
                                <div>
                                    <!--" -->
                                    <!-- v-b-modal.modal-prevent-closing title="Update Status" -->
                                    <span v-if="requisition.status == 'SETTLED'">
                                        <b-badge pill variant="success">{{ requisition.status }}</b-badge>
                                    </span>
                                    <span v-if="requisition.status == 'UNSETTLED'">
                                        <b-badge pill variant="warning">{{ requisition.status }}</b-badge>
                                    </span>
                                    <span v-if="requisition.status == 'APPROVED'">
                                        <b-badge pill variant="success">{{ requisition.status }}</b-badge>
                                    </span>
                                    <span v-if="requisition.status == 'PENDING'"  @click="checkUserPermission(detail.status)" style="cursor: pointer;">
                                        <b-badge pill variant="primary">{{ requisition.status }}</b-badge>
                                    </span>
                                     <span v-if="requisition.status == 'DUE'" @click="checkUserPermission(detail.status)" style="cursor: pointer;">
                                        <b-badge variant="warning">{{ requisition.status }}</b-badge>
                                    </span>
                                    <span  v-if="requisition.status == 'REJECTED'" @click="checkUserPermission(detail.status)" style="cursor: pointer;">
                                        <b-badge variant="danger">{{ requisition.status }}</b-badge>
                                    </span>
                                </div>
                            </div>
                 
                           <div class="row" v-if="settlement_list && settlement_list.length">
                                <div class="col">
                                    <div class="form-group">

                                    <div class="d-flex justify-content-between align-items-center mb-2" v-if="detail.status === 'UNSETTLED'">
                                        <label class="font-weight-bold" style="font-size: 18px;">Settlement</label>

                                        <!-- <b-button variant="success" v-b-modal.modal-settlement-approved>
                                        Settle
                                        </b-button> -->
                                    </div>

                                    <ItemTable
                                        v-if="settlement_list && settlement_list.length"
                                        id="settlement-table-req"
                                        :tableData="settlement_list"
                                        style="margin-bottom: 10px;"
                                    />
                                    </div>
                                </div>
                            </div>

                            <div class="row" v-if="settlement_list && settlement_list.length">
                                <div class="col-sm-4"></div>
                                <!-- <div class="col-sm-8">
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">Grand Total</label>
                                        <input style="height: 44px;" class="form-control" type="number" placeholder="Enter grand total" disabled v-model="requisition.grand_total" />
                                    </div>
                                </div> -->
                                <div class="col-sm-8" >
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 160px;">Revised Total</label>
                                        <p class="form-control d-flex align-items-center" style="height: 44px; font-size: 14px;">{{ revisedTotal }}</p>
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="row">
                                <div class="col">
                                    <div class="form-group mb-0">
                                        <button @click="onSubmit" class="btn btn-success mr-3">Submit</button>
                                        <router-link to="/finance-and-accounts/account/requisition/list">
                                            <button class="btn btn-danger" href="#">Go Back</button>
                                        </router-link>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </px-card>
            </div>

            <div class="col-xl-4">
                <div v-if="requisition.approved_by">
                    <px-card class="no-print">
                        <div class="content-container-attahment">
                            <h6>Approved By</h6>
                            <div style="margin-top: 16px; font-size: larger;">{{ requisition.approved_by?.full_name }}</div>
                            <div style="margin-top: 6px; font-size: larger;">{{ requisition.approved_by?.email }}</div>
                        </div>
                    </px-card>
                </div>

                <px-card class="no-print">
                    <div class="content-container-attahment no-print w-100">
                        <div>
                            <div class="d-flex justify-content-between" style="margin-bottom: 12px;">
                                <h6>Supporting Documents</h6>
                                <feather type="plus-square" size="22px" style="color: #ff595d; cursor: pointer;" v-b-modal.modal-scrollable-add-document v-b-tooltip.hover title="Add Documents"></feather>
                            </div>

                            <b-table show-empty sticky-header :items="detail.requisition_attach" :fields="Attachment" head-variant="light">
                                <template #cell(index)="data">
                                    {{ data.index + 1 }}
                                </template>

                                <template #cell(title)="data">
                                    <a :href="host+data.item.requisition_attachment" target="_blank">
                                        {{ truncateText(data.item.attach_title, 100) }}
                                        <br/>
<small v-if="data.item.note" style="font-style: italic;">Note:{{data.item.note ? truncateText(data.item.note, 30) : '' }}</small>
                                    </a>
                                </template>

                                <template #cell(action)="data">
                                    <div style="display: flex; flex-direction: row; gap:10px">
                                        <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover title="Delete" @click="deleteAttach(data.item.id)"></feather>
                                    </div>
                                </template>
                            </b-table>
                        </div>
                    </div>
                </px-card>

                <px-card>
                    <div class="content-container-attahment w-100">
                        <div>
                            <div class="d-flex justify-content-between" style="margin-bottom: 12px;">
                                <h6>Payments</h6>
                            </div>

                            <b-table show-empty sticky-header :items="paymentList" :fields="payments" head-variant="light">
                                <template #cell(index)="data">
                                    {{ data.index + 1 }}
                                </template>

                                <template #cell(requested_by)="data">
                                    <span :title="data.item.date" v-b-tooltip.hover>{{ data.item.requested_by.username }}</span>
                                </template>


    <!--  -->
                                <template #cell(status)="row">
                                    <span v-if="row.value == 'APPROVED'">
                                        <b-badge variant="success">{{ row.value }}</b-badge>
                                    </span>
                                    <span @click="getStatus(row.item, row.item.id)" v-if="row.value == 'PENDING'">
                                        <b-badge variant="primary" v-b-modal.modal-prevent-closing>{{ row.value }}</b-badge>
                                    </span>
                                    <span @click="getStatus(row.item, row.item.id)" v-if="row.value == 'REJECTED'">
                                        <b-badge variant="danger" v-b-modal.modal-prevent-closing>{{ row.value }}</b-badge>
                                    </span>
                                </template>
                            </b-table>
                        </div>
                    </div>
                </px-card>
            </div>
        </div>
    </div>


    <!-- Requisition Settlement -->
    <b-modal id="modal-requisition-settlement" size="xl" ref="modal" title="Requisition Settlement" @ok="handleSettlement">
        <form ref="form" @submit.stop.prevent="handleSettlementSubmit">
            
            <div class="row">
                <div class="col">
                 
                    <div class="form-group">
                        <SettlementItemTable v-if="settlement" style="margin-bottom: 10px;" id="settlement-table" :settlementData="settlement" @settlementUpdated="updateSettlement" />
                    </div>

                   

                </div>
            </div>
        </form> 
    </b-modal>

    <!-- Project Attachment Create -->
    <b-modal id="modal-scrollable-add-document" ref="modal" title="Add document" @ok="handleAttachOk">
        <form ref="form" @submit.stop.prevent="handleAttahmentSubmit">
             <div class="row">
    <div class="col-sm-12">
        <div class="form-group">
            <label>Supporting note </label>
            <input class="form-control" type="text" placeholder="Enter supporting note ..." v-model="add_attachment.note">
        </div>
    </div>
</div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>Upload Documnets</label>
                        <b-form-file placeholder="Choose files  or drop them here..." drop-placeholder="Drop file here..." @change="uploadAttachFile"></b-form-file>
                    </div>
                </div>
            </div>
        </form>
    </b-modal>


    <b-modal id="modal-prevent-closing" ref="modal" title="Update Requisition Status" @show="resetModal" @hidden="resetModal" @ok="handleStatusOk">
        <form ref="form" @submit.stop.prevent="handleSubmit">
            <b-form-group label="Status" label-for="name-input">
                <b-form-select v-model="selectedStatus" :options="statuses"></b-form-select>
            </b-form-group>
        </form>
    </b-modal>

    <!-- Payment Status Change -->
    <!-- <b-modal id="modal-prevent-closing" ref="modal" title="Update Payment Status" @ok="handlePaymentStatusOk">
        <form ref="form" @submit.stop.prevent="handlePayementStatusSubmit">
            <b-form-group label="Status" label-for="name-input">
                <b-form-select v-model="selectedStatus" :options="statuses"></b-form-select>
            </b-form-group>
        </form>
    </b-modal> -->

    <!-- Settlement approved -->
    <b-modal id="modal-settlement-approved" centered hide-header @ok="handleApproveSettlement()">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to approve this settlement?</div>
    </b-modal>

    <!-- Payment Approve -->
    <b-modal id="modal-prevent-status" ref="modal" title="Add Transaction" size="xl" hide-footer>
        <paymentApproveVue :amount="this.approved_status" :paymentType="'REQUISITION'" />
    </b-modal>


          <!-- Refer and Chat -->
    <b-modal id="modal-scrollable" ref="modal" title="Requsition Reply" hide-footer @hidden="resetModal" @ok="handleOk">
        <h6>Already Refered</h6>

        <div class="row">
            <div class="text-center col-sm-6 w-full" v-for="user in detail.refering_to" :key="user.id" v-b-tooltip.hover v-b-modal.modal-center-deleteAlocation @click="deletetAllocation(user.id)" title="Delete">
                <div class="w-100 mb-2 badge-style">
                    <h7>{{ user.first_name}} {{ user.last_name }}</h7>
                    <b-icon icon="x" style="color: white;"></b-icon>
                </div>
            </div>
        </div>

        <multiselect v-model="chatMembers" tag-placeholder="Add member" placeholder="Search or add a member" label="full_name" :max="user_list.length" :options="formattedUserList" track-by="id" :multiple="true" :taggable="true"></multiselect>

        <!-- v-if="eod_reply.length > 0" -->
        <div style="margin-top: 30px;">
            <h6>Replies</h6>
          
            <div class="task-board-comments">
                <div v-for="reply in req_replies" :key="reply.id" class="chatbox">
                    <div class="chat">
                        <div class="avatar">
                            <img :src="host + reply.replier_photo" alt="" v-b-tooltip.hover :title="reply.replied_by.first_name + ' ' + reply.replied_by.last_name">
                        </div>
                        <div class="message">
                            <h7 class="name pl-1">{{ reply.replied_by.username }}</h7>
                            <!-- <p class="msg" v-b-tooltip.hover :title="reply.reply_date">{{ reply.reply }}</p> -->
                            <p class="msg" v-html="convertUrls(reply.reply)"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="task-board-comment-box" style="margin-top: 10px;">
            <div style="display: flex; gap: 12px;">
                <input class="form-control" type="text" v-model="my_reply.reply" placeholder="Write your reply here..." @keyup.enter="handleReplySubmit()">
                <button @click="handleReplySubmit()" class="btn btn-primary">Send</button>
            </div>
        </div>
    </b-modal>
    <b-modal id="modal-center-deleteAlocation" centered hide-header @ok="handleAllocationDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to remove this refer?</div>
    </b-modal>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Datepicker from 'vuejs-datepicker';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import {
    computed
} from "vue";
import ItemTable from "../../requisition/edit-item-table.vue";
import SettlementItemTable from "../../requisition/settlement-item-table.vue";
import Multiselect from 'vue-multiselect';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import {
    myHost
} from "../../../../_helpers/host";
import paymentApproveVue from '../../accounts/payments/payment-approve.vue';

export default {
    components: {
        vueDropzone: vue2Dropzone,
        Datepicker,
        ItemTable,
        SettlementItemTable,
        Multiselect,
        paymentApproveVue
    },

    data() {
        return {
            host: myHost.host,
            add_attachment: {
                requisition_attachment: null,
                requisition_id: '',
                note:null,
            },
            settlement: null,
            assignedMembers: [],
            chatMembers:[],
            requisition: {
                requisition_id: '',
                title: '',
                date: null,
                raised_by: null,
                refering_to: [],
                details: null,
                type: null,
                project: null,
                total: computed(() => {
                    let total = 0;
                    if (this.requisition.details.length >= 1) {
                        this.requisition.details.map((item) => {
                            total = total + item.amount;
                        });
                    }
                    return total;
                }),
                // grand_total: computed(() => {
                //     if (this.requisition.total !== 0) {
                //         const tax = this.requisition.vat_tax || 0;
                //         const discount = this.requisition.discount || 0;
                //         let gtotal =
                //             this.requisition.total +
                //             tax * (this.requisition.total / 100) -
                //             discount * (this.requisition.total / 100);
                //         return Math.round((gtotal + Number.EPSILON) * 100) / 100;
                //     }
                //     return 0;
                // }),
                grand_total: null,
                due_amount: null,
                note: ''
            },
            approved_status: {
                update_id: '',
                amount: null,
                detail_id: null,
            },
            Attachment: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'title',
                    label: 'Title',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: true
                }
            ],
            settlement_list:[],
            settlement_id:null,
            payments: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'requested_by',
                    label: 'Requested By',
                    sortable: true
                },
                {
                    key: 'paid_amount',
                    label: 'Request Amount',
                    sortable: true
                },

                {
                    key: 'status',
                    label: 'Status',
                    sortable: true
                }
            ],
            payment: '',
            statuses: ['DUE', 'PENDING', 'APPROVED', 'REJECTED'],
            // statuses: ['APPROVED', 'PENDING', 'REJECTED'],
            selectedStatus: '',
            my_reply: {
                id: '',
                reply: '',
                refer_to: '',
            },
            temp_id : null,

              user: null,
        };
    },

    computed: {
        ...mapState({
            user_list: state => state.employee.employee_list,
            detail: state => state.requisition.requisition_detail,
            settlementDetail : state => state.requisition.settlement_detail,
            projects: state => state.project.project,
            requ_types: state => state.requisition.requisition_type,
            paymentList: state => state.requisition.requisitionPaymentList,
            req_replies: state => state.requisition.req_reply
        }),
        revisedTotal() {
            let total = 0;
            if (this.settlementDetail?.details?.length) {
                this.settlementDetail.details.forEach(item => {
                    const amount = Number(item.amount) || 0;
                    total += amount;
                });
            }
            return total;
        },
        formattedUserList() {
            return this.user_list.map(user => ({
                ...user,
                full_name: `${user.first_name} ${user.last_name}`
            }));
        },

    },
    created() {
        this.user = JSON.parse(localStorage.getItem('user'))
    },

    mounted() {
        this.$store.dispatch("employee/fetchEmployeeList");
        this.$store.dispatch("project/fetchProject");
        this.$store.dispatch("requisition/fetchRequisitionType")
        
        this.$store.dispatch("requisition/fetchRequisitionDetail", this.$route.params.id).then(() => {
            // this.$store.dispatch("requisition/fetchSettlementByRequisition", {id:this.detail.id})
            // this.$store.dispatch("requisition/fetchRequisitionPaymentByRequisition", this.detail.id)
        });
    },

    watch: {
        detail(newValue, oldValue) {
            this.requisition.id = this.detail.id
            this.requisition.title = this.detail.title
            this.requisition.approved_by = this.detail.approved_by
            this.requisition.type = this.detail ?.type
            this.requisition.requisition_id = this.detail.requisition_id
            this.requisition.raised_by = this.detail.raised_by.full_name
            this.requisition.date = this.detail.created_at
            this.requisition.details = this.detail.details
             this.requisition.status = this.detail.status
            this.requisition.total = this.detail.total
            this.requisition.grand_total = this.detail.grand_total
            this.requisition.note = this.detail.note
            this.requisition.due_amount = this.detail.due_amount
            this.assignedMembers = this.detail.refering_to
            this.requisition.project = this.detail ?.project


            if (!newValue || !this.user) return;

            const currentUserId = this.user.user_object.id;

            const isMatched = newValue.refering_to?.some(
                item => item.id === currentUserId
            );

            if (!isMatched) {
                this.$router.replace('/no-access');
            }
        },
        settlementDetail(oldValue, newValue) {
            this.settlement_id = this.settlementDetail  ?this.settlementDetail ?.id : null
            this.settlement_list = this.settlementDetail ?.details  ?this.settlementDetail ?.details : []
        },
        chatMembers: {
            handler: function (newVal, oldVal) {
                this.storeAssignedMembers(newVal);
            },
            deep: true
        },
        
        
        
    },

    methods: {
        checkUserPermission(status) {
            const currentUserId = this.user.user_object.id;

            const isMatched = this.detail?.refering_to.some(
            (item) => item.id === currentUserId
            );

            if (isMatched) {
                this.$nextTick(() => {
                    this.$bvModal.show('modal-prevent-closing')
                })
                this.getStatus(status)
            } else {
                Swal.fire({
                    title: "Error!",
                    text: 'You do not have permission to access this.',
                    icon: "error"
                });

            }
        },
          storeAssignedMembers(assignedMembers) {
            const latestId = assignedMembers[assignedMembers.length - 1].id;

            this.$store.dispatch("requisition/RequisitionAddRefer", {
                id: this.my_reply.id,
                refer_id: latestId,
                    ReqDetail:true
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.chatMembers = [];

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
            this.$nextTick(() => {
                this.$bvModal.hide('modal-scrollable')
            })
        },
        handleAllocationDeleteOk() {
            this.$store.dispatch("requisition/RequisitionDeleteRefer", {
                id: this.$route.params.id,
                refer_id: this.temp_id,
                ReqDetail:true
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.assignedMembers = '';
                    this.$nextTick(() => {
                        this.$bvModal.hide('modal-center-deleteAlocation')
                    })

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },
        deletetAllocation(id) {
            this.temp_id = id
        },
        resetModal() {
            this.name = ''
            this.nameState = null
        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },
        goBack() {
            if (window.history.length > 1) {
                this.$router.back();
            } else {
                this.$router.push('/dashboard');
            }
        },

        formatDate(dateTimeString) {
            const date = new Date(dateTimeString);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },

        printPdf(section) {
            this.downloadPdf = true;

            const printContents = document.getElementById(section).innerHTML;
            const originalContents = document.body.innerHTML;
            const wrappedPrintContents = `<div class="page">${printContents}</div>`;

            document.body.innerHTML = wrappedPrintContents;

            // document.body.classList.add('print-mode');

            window.print();

            document.body.classList.remove('print-mode');
            document.body.innerHTML = originalContents;

            location.reload();
        },

        getStatus(status, id) {
            this.selectedStatus = status
        },

        // getStatus(status, id) {
        //     this.approved_status.amount = status.paid_amount
        //     this.approved_status.update_id = id
        //     this.approved_status.detail_id = status.requisition.id
        //     this.selectedStatus = status.status
        // },

        truncateText(text, maxLength) {
            if (text.length > maxLength) {
                return text.substring(0, maxLength) + '...';
            } else {
                return text;
            }
        },

        handleAttachOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleAttahmentSubmit()
        },

        handleAttahmentSubmit() {
            this.add_attachment.requisition_id = this.$route.params.id
            this.$store.dispatch("requisition/addRequistionAttachment", {
                attachment: this.add_attachment,
                requisition_id: this.$route.params.id
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.add_attachment.requisition_attachment = null
                    this.add_attachment.note = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-scrollable-add-document')
            })
        },
        handleApproveSettlement(){
            this.settleApproved()
        },
        settleApproved(){
             this.$store.dispatch("requisition/settlementApproval", {
                requisition: this.$route.params.id,
                settlement: this.settlement_id,
                status:'APPROVED',
               
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.payment = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

        settleRequisition() {
            // this.settlement = this.requisition.details
               this.settlement = JSON.parse(JSON.stringify(this.requisition.details))
        },

        handleSettlement(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSettlementSubmit()
        },

        handleSettlementSubmit() {
             this.$store.dispatch("requisition/settleRequisition", {
                requisition: this.$route.params.id,
                details:this.settlement,
               
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.payment = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
            this.$nextTick(() => {
                this.$bvModal.hide('modal-requisition-settlement')
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-requisition-settlement')
            })
        },

        deleteAttach(id) {
            this.$store.dispatch("requisition/deleteAttachmentFromRequisition", {
                id: id,
                requisition_id: this.$route.params.id
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

        uploadAttachFile(e) {
            this.add_attachment.requisition_attachment = e.target.files[0]
        },

        updateItems(data) {
            if (data) {
                this.requisition.details = data;
            }
        },

        updateSettlement(data) {
            // console.log(data)
            this.settlement = data

           
        },
      

        // onSubmit() {
        //     this.assignedMembers.map(item => this.requisition.refering_to.push(item.id));
        //     this.$store.dispatch("requisition/updateRequisition", this.requisition).then(response => {
        //         if (response.code == 200) {
        //             Swal.fire({
        //                 title: "Success!",
        //                 text: response.response,
        //                 icon: "success"
        //             });
        //             setTimeout(() => this.$router.push('/finance-and-accounts/account/requisition/list'), 2000)
        //         } else {
        //             Swal.fire({
        //                 title: "Error!",
        //                 text: response.response,
        //                 icon: "error"
        //             });
        //         }
        //         this.$nextTick(() => {
        //             this.$bvModal.hide('modal-prevent-closing')
        //         })
        //     })
        // },

        handlePaymentStatusOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handlePayementStatusSubmit()
        },

        handlePayementStatusSubmit() {
            if (this.selectedStatus === 'APPROVED') {
                this.$nextTick(() => {
                    this.$bvModal.show('modal-prevent-status')
                })
            } else {
                this.$store.dispatch("payments/updateRequisitionPaymentStatus", {
                    id: this.approved_status.update_id,
                    status_for_change: this.selectedStatus,
                    detail_id: this.approved_status.detail_id
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })

                this.$nextTick(() => {
                    this.$bvModal.hide('modal-prevent-closing')
                })
            }

        },
        Reply(type) {
            // console.log(type)
            this.my_reply.id = type.id
            this.my_reply.reply = type.name
            this.my_reply.refer_to = type.reported_to
            this.$store.dispatch("requisition/fetchReqReply", this.my_reply.id)
        },
          handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleReplySubmit()
        },
           convertUrls(text) {
            if (text === null) {
                return '';
            }
            const urlPattern = /(https?:\/\/[^\s<]+)/g;
            return text.replace(urlPattern, (url) => {
                return `<a href="${url}" target="_blank" class="text-primary">${url}</a>`;
            });
        },


        handleReplySubmit() {
            if (this.my_reply.reply) {
                this.$store.dispatch("requisition/addReqReply", {
                    req: this.my_reply.id,
                    reply: this.my_reply.reply
                }).then(response => {

                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        
                        this.my_reply.reply = ''

                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })

                // this.$nextTick(() => {
                //     this.$bvModal.hide('modal-scrollable')
                // })
            }
        },
         handleStatusOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },

        handleSubmit() {
            this.$store.dispatch("requisition/updateRequisitionStatus", {
                id: this.$route.params.id,
                status_for_change: this.selectedStatus,
                from_details:true
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },

        // handlePayementSubmit() {
        //     this.$store.dispatch("requisition/updatePaymentStatus", {
        //         detail_id: this.$route.params.id,
        //         id: this.payment,
        //         status: this.selectedStatus
        //     }).then(response => {
        //         if (response.code == 200) {
        //             Swal.fire({
        //                 title: "Success!",
        //                 text: response.response,
        //                 icon: "success"
        //             });
        //             this.payment = null
        //         } else {
        //             Swal.fire({
        //                 title: "Error!",
        //                 text: response.response,
        //                 icon: "error"
        //             });
        //         }
        //     })
        //     this.$nextTick(() => {
        //         this.$bvModal.hide('modal-prevent-closing-status')
        //     })
        // },
    }
};
</script>

<style scoped>
.content-container-attahment {
    /* background-color: white; */
    padding: 16px;
}

@media print {
    #requisition {
        padding: 20px !important;
    }

    .no-print {
        display: none !important;
    }
}



.badge-style {
    display: flex;
    gap: 20px;
    justify-content: space-between;
    align-items: center;
    justify-items: center;
    background-color: #2c323f;
    padding: 0.375rem 1.75rem;
    color: white;
}

.badge-style:hover {
    background-color: #ff595d;
}

.badge-style {
    display: flex;
    justify-content: space-between;
    align-items: center;
    justify-items: center;
    background-color: #2c323f;
    padding: 0.375rem 1.75rem;
    color: white;
}

.badge-style:hover {
    background-color: #ff595d;
}

.chatbox {
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding: 0px 10px;
}

.chat {
    display: flex;
    gap: 10px;
    justify-content: center;
    align-items: center;
    word-break: break-all;
}

.avatar img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
    border: solid 2px white;
}

.message {
    flex-grow: 1;
}

.msg {
    background: #fff0f0;
    width: 100%;
    /* Ensures message takes full width */
    padding: 10px;
    border-radius: 10px;
    position: relative;
    font-size: 13px;
    word-break: break-all;
}

.task-board-comments {
    height: 450px;
    overflow-y: auto;
}

/* height */
::-webkit-scrollbar {
    height: 6px;
    width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
    background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #555;
}
</style>
